export default "__VITE_ASSET__D492dtO3__"